import React, { createContext, useContext, ReactNode, useState } from "react";

interface SearchHighlightContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isSearchActive: boolean;
}

const SearchHighlightContext = createContext<
  SearchHighlightContextType | undefined
>(undefined);

interface SearchHighlightProviderProps {
  children: ReactNode;
}

export const SearchHighlightProvider: React.FC<
  SearchHighlightProviderProps
> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState<string>("");

  const value = {
    searchQuery,
    setSearchQuery,
    isSearchActive: Boolean(searchQuery?.trim())
  };

  return (
    <SearchHighlightContext.Provider value={value}>
      {children}
    </SearchHighlightContext.Provider>
  );
};

export const useSearchHighlight = (): SearchHighlightContextType => {
  const context = useContext(SearchHighlightContext);

  if (context === undefined) {
    return {
      searchQuery: "",
      setSearchQuery: () => {},
      isSearchActive: false
    };
  }

  return context;
};

export default SearchHighlightContext;
